module.exports = __webpack_public_path__ + "img/0-46.34cdb5b5.jpg";